<section class="summary-section">

  <mat-card id="unprocessedVsProcessedSummaryCard" class="summary-chart-card">

    <mat-toolbar class="chart-card-header-toolbar">
      <div class="right">
        <span class="chart-card-title summary-chart-card-title">
          Unprocessed Inventory - Today
          @if (auth.businessType() == 'Dealer') {
            <span class="chart-exception-title">*</span>
          }
        </span>
      </div>
      <!-- <div class="left">
        <button
          mat-button
          color="primary">
          <mat-icon iconPositionEnd>arrow_forward</mat-icon>
          Open 'Inventory Unprocessed' Report
        </button>
      </div> -->
    </mat-toolbar>

    <mat-card-content>

      <!-- <span>Count and share of unprocessed vehicles on your lot(s) vs total inventory (based on last inventory feed transmitted by your provider)
      </span> -->

      <span>Count of unprocessed vehicles on your lot(s) (based on last inventory feed transmitted by your provider)
      </span>

      @if (auth.businessType() == 'Dealer') {
        
        <span class="chart-exception-text">*Pre-owned inventory for sale only. Excludes new vehicles and loaners.</span>

        <!-- <div class="chart-exception-warn-text-wrapper">
          <mat-icon>warning</mat-icon>
          <span class="chart-exception-warn-text">*Showing Used vehicles only. <br> *New/Loaner vehicles are excluded from this report.</span>
        </div> -->

        }

      @if (unprocessedVsProcessedCountsLoading) {
        <div class="loader-wrapper">
          <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
        </div>
      } @else if (inventory().total) {

        <!-- <p class="inventory-total">Total Current Inventory: {{ inventoryTotalLabel() }}</p> -->

        <div class="inventory-wrapper">

          <!-- <div class="inventory-chart-container">
            <canvas
              baseChart
              [type]="pieChartType"
              [data]="inventoryChartData()"
              [options]="inventoryChartOptions()"
              [plugins]="inventoryChartPlugins">
            </canvas>
          </div> -->

          <!-- <div class="inventory-legend">
            @for (entry of inventoryLegend(); track entry.label) {
              <div class="inventory-legend-row">
                <span class="inventory-legend-swatch" [style.background-color]="entry.color">
                </span>
                <span>{{entry.label}}</span>
              </div>
            }
          </div> -->
          
          <div class="inventory-legend-swatch-card-container">
            @for (entry of inventoryLegend(); track entry.label) {

              <!-- <mat-card class="inventory-legend-swatch-card" [style.border-color]="entry.color">

                <span class="inventory-legend-swatch-rich" [style.background-color]="entry.color" [style.color]="entry.fontColor">

                  <span class="swatch-hero">
                    
                    <span class="inventory-legend-swatch-share">{{entry.share}}% </span>
                    
                    <span class="inventory-legend-swatch-label">{{entry.label}}</span>

                  </span>

                  <mat-divider style="padding-bottom:0.5em"></mat-divider>
                  
                  <span class="inventory-legend-swatch-count">{{entry.count == '1' ? entry.count + ' vehicle' :  entry.count + ' vehicles'}} </span>

                </span>

                <span class="inventory-legend-swatch-text" [style.color]="entry.color">{{entry.text}}</span>

              </mat-card> -->

              <mat-card class="inventory-legend-swatch-card" [style.border-color]="entry.color">

                <span class="inventory-legend-swatch-rich" [style.background-color]="entry.color" [style.color]="entry.fontColor">

                  <span class="swatch-hero">
                    
                    <span class="inventory-legend-swatch-count">{{entry.count}}</span>
                    
                    <span class="inventory-legend-swatch-label">{{entry.count == '1' ? 'vehicle ' + entry.label : 'vehicles ' + entry.label}} </span>

                  </span>

                </span>

                <span class="inventory-legend-swatch-text" [style.color]="entry.color">{{entry.text}}</span>

              </mat-card>
            }
          </div>

        </div>

      } @else {
        <p class="inventory-empty">No inventory reported.</p>
      }

    </mat-card-content>

    <!-- <mat-card-actions>
      <button mat-button color="primary" routerLink="/inventory-unprocessed">
          <mat-icon iconPositionEnd>arrow_forward</mat-icon>
          Open 'Inventory Unprocessed' Report
        </button>
    </mat-card-actions> -->

  </mat-card>

</section>

<mat-card class="table-card">
  <mat-toolbar class="chart-card-header-toolbar">
    <div class="right">
      <span class="chart-card-title">Inventory Unprocessed Details</span>
      @if (auth.businessType() == 'Dealer') {
        <span class="chart-exception-subtitle">*Pre-owned inventory for sale only. Excludes new vehicles and loaners.</span>
      }
    </div>
    <div class="left">
      <button mat-raised-button color="primary" [matTooltip]="csvDownloadHint" (click)="exportUnprocessedVinReportCSV()">
        <mat-icon>download</mat-icon>
        Export to CSV
      </button>
    </div>

  </mat-toolbar>

  @if (tableLoading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <div class="filter-bar-wrapper">
    <app-filter-bar fixedEndDate />
  </div>

  <div class="table-scroll">
    <table class="unProcessed-vin-table" mat-table [dataSource]="dataSource.filteredData">

      <ng-container matColumnDef="dateInInventory">
        <th mat-header-cell *matHeaderCellDef mat-header>
          <span class="table-header-span">Date In Inventory<mat-icon [matTooltip]="tableHeaderTooltips.dateInInventory">info_outline</mat-icon></span>
        </th>
        <td mat-cell *matCellDef="let row">{{formatDateTime(row.dateInInventory)}}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-header>
          <span class="table-header-span">Status<mat-icon [matTooltip]="tableHeaderTooltips.status">info_outline</mat-icon></span>
        </th>
        <td mat-cell *matCellDef="let row">{{row.status}}</td>
      </ng-container>

      <ng-container matColumnDef="vinCode">
        <th mat-header-cell *matHeaderCellDef mat-header>
          <span class="table-header-span">VIN Code<mat-icon [matTooltip]="tableHeaderTooltips.vinCode">info_outline</mat-icon></span>
        </th>
        <td mat-cell *matCellDef="let row">{{row.vinCode}}</td>
      </ng-container>

      <ng-container matColumnDef="decodedMake">
        <th mat-header-cell *matHeaderCellDef mat-header>
          <span class="table-header-span">Decoded Make<mat-icon [matTooltip]="tableHeaderTooltips.decodedMake">info_outline</mat-icon></span>
        </th>
        <td mat-cell *matCellDef="let row">{{row.decodedMake}}</td>
      </ng-container>

      <ng-container matColumnDef="decodedModel">
        <th mat-header-cell *matHeaderCellDef mat-header>
          <span class="table-header-span">Decoded Model<mat-icon [matTooltip]="tableHeaderTooltips.decodedModel">info_outline</mat-icon></span>
        </th>
        <td mat-cell *matCellDef="let row">{{row.decodedModel}}</td>
      </ng-container>

      <ng-container matColumnDef="decodedYear">
        <th mat-header-cell *matHeaderCellDef mat-header>
          <span class="table-header-span">Decoded Year<mat-icon [matTooltip]="tableHeaderTooltips.decodedYear">info_outline</mat-icon></span>
        </th>
        <td mat-cell *matCellDef="let row">{{row.decodedYear}}</td>
      </ng-container>

      <ng-container matColumnDef="processorSite">
        <th mat-header-cell *matHeaderCellDef mat-header>
          <span class="table-header-span">Processor Site<mat-icon [matTooltip]="tableHeaderTooltips.processorSite">info_outline</mat-icon></span>
        </th>
        <td mat-cell *matCellDef="let row">{{row.processorSite}}</td>
      </ng-container>

      <ng-container matColumnDef="username">
        <th mat-header-cell *matHeaderCellDef mat-header>
          <span class="table-header-span">User Name<!-- <mat-icon [matTooltip]="tableHeaderTooltips.username">info_outline</mat-icon> --></span>
        </th>
        <td mat-cell *matCellDef="let row">{{row.userName}}</td>
      </ng-container>

      <ng-container matColumnDef="controllerName">
        <th mat-header-cell *matHeaderCellDef mat-header>
          <span class="table-header-span">Controller Name<mat-icon [matTooltip]="tableHeaderTooltips.controllerName">info_outline</mat-icon></span>
        </th>
        <td mat-cell *matCellDef="let row">{{row.controllerName}}</td>
      </ng-container>

      <ng-container matColumnDef="controllerId">
        <th mat-header-cell *matHeaderCellDef mat-header>
          <span class="table-header-span">Controller ID<mat-icon [matTooltip]="tableHeaderTooltips.controllerId">info_outline</mat-icon></span>
        </th>
        <td mat-cell *matCellDef="let row">{{row.controllerID}}</td>
      </ng-container>

      <ng-container matColumnDef="classification">
        <th mat-header-cell *matHeaderCellDef mat-header>
          <span class="table-header-span">Classification<mat-icon [matTooltip]="tableHeaderTooltips.classification">info_outline</mat-icon></span>
        </th>
        <td mat-cell *matCellDef="let row">{{row.classification}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <tr class="no-data-row" *matNoDataRow>
        <td [attr.colspan]="displayedColumns.length">No scans match the filter.</td>
      </tr>
    </table>
  </div>

  <!-- Disabled while loading: cursor pagination can't skip a page it hasn't
       fetched, so a second click before the first lands would desync the
       paginator from the rows. -->
  <mat-paginator [disabled]="tableLoading" [pageSize]="data.scanTablePagination().pageSize" [length]="data.scanTablePagination().total" (page)="paginatorEventHandler($event)"></mat-paginator>

</mat-card>
